<div class="modal-wrapper">
  <div class="modal-header">
    <h2>{{ glass.name }}</h2>
    <button class="close-btn" (click)="close()">
      <ion-icon name="close"></ion-icon>
    </button>
  </div>

  <div class="modal-content">
    <div class="info-row">
      <span class="info-label">{{'filter_category' | translate}}</span>
      <span class="info-value">{{ glass.category ? (glass.category | translate) : '-' }}</span>
    </div>

    <div class="info-row">
      <span class="info-label">{{'HEADER_TYPE' | translate}}</span>
      <span class="info-value">{{ glass.type || '-' }}</span>
    </div>

    <div class="info-row">
      <span class="info-label">{{'filter_structure' | translate}}</span>
      <span class="info-value">{{ glass.structure }}</span>
    </div>

    <div class="info-row">
      <span class="info-label">{{'cavity' | translate}}</span>
      <span class="info-value">{{ getCavityDisplay() }}</span>
    </div>

    <div class="info-row">
      <span class="info-label">{{'thickness' | translate}}</span>
      <span class="info-value">{{ glass.thickness }} mm</span>
    </div>

    <div class="info-row">
      <span class="info-label">{{'UG' | translate}}</span>
      <span class="info-value">{{ glass.ug }} W/m²K</span>
    </div>

    <div class="info-row">
      <span class="info-label">{{'lightTransmittance' | translate}}</span>
      <span class="info-value">{{ glass.lightTransmittance }}%</span>
    </div>

    <div class="info-row">
      <span class="info-label">{{'G-VALUE' | translate}}</span>
      <span class="info-value">{{ glass.gValue }}%</span>
    </div>
  </div>
  <p></p>
</div>
